import React from 'react';
import { personal } from '../data';
import './Nav.css';

const links = [
  { id: 'experience', label: 'Experience' },
  { id: 'projects',   label: 'Projects' },
  { id: 'skills',     label: 'Skills' },
  { id: 'about',      label: 'About' },
];

export default function Nav() {
  return (
    <header className="nav">
      <div className="nav__inner">
        <a className="nav__mark" href="#top" aria-label="Back to top">
          <svg className="nav__peak" viewBox="0 0 32 22" aria-hidden="true">
            <path d="M1 21 L11 6 L15 12 L20 3 L31 21 Z" fill="currentColor" />
            <path d="M20 3 L23.6 9.6 L21.2 8.4 L19.4 10.4 L17.6 7.4 Z" fill="#8FA6B5" />
          </svg>
          <span>{personal.name} {personal.lastName}</span>
        </a>

        <nav className="nav__links" aria-label="Sections">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`}>{l.label}</a>
          ))}
          <a className="nav__cta" href="#contact">Contact</a>
        </nav>
      </div>
    </header>
  );
}
